/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GcpResourceSkuDetailsResponse {
    getFixupPrototypeFunction() { return GcpResourceSkuDetailsResponse.fixupPrototype; }

    static newInstance(model: Partial<GcpResourceSkuDetailsResponse>): GcpResourceSkuDetailsResponse {
        let obj = Object.assign(new GcpResourceSkuDetailsResponse(), model);
        GcpResourceSkuDetailsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GcpResourceSkuDetailsResponse>): GcpResourceSkuDetailsResponse {
        if (!model) return null;
        return GcpResourceSkuDetailsResponse.newInstance(<GcpResourceSkuDetailsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GcpResourceSkuDetailsResponse) {
        if (!obj) return;

        models.GcpResourceSkuDetailsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GcpResourceSkuDetailsResponse): boolean {
        Object.setPrototypeOf(obj, GcpResourceSkuDetailsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * SKU list
     */
    sku_list: Array<string>;

}
